import { plainToInstance } from 'class-transformer'
import { Entity } from '@core/entities/entity'
import { ITaskAttachment } from './ITaskAttachment'

export class TaskAttachment extends Entity<ITaskAttachment> {
  key: string
  type: 'PDF' | 'PNG'
  mimeType?: string
  getUrl: string
  downloadUrl: string

  public static new(payload: unknown): TaskAttachment {
    const entity = plainToInstance(TaskAttachment, payload)
    return entity
  }
}
